module.exports = __webpack_public_path__ + "static/img/zhanting.d7106f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/AboutUs/zhanting.png
// module id = qKPO
// module chunks = 12